export const LOADING = 'LOADING'

export const resetLoading = (key) => ({
  type: LOADING,
  key,
  status: undefined,
})
